"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.vogelAcademyVideoStatusTranslation = exports.VogelAcademyVideoStatus = void 0;
var VogelAcademyVideoStatus;
(function (VogelAcademyVideoStatus) {
    VogelAcademyVideoStatus["CANCELLED"] = "cancelled";
    VogelAcademyVideoStatus["ERROR"] = "error";
    VogelAcademyVideoStatus["PROCESSING"] = "processing";
    VogelAcademyVideoStatus["READY"] = "ready";
    VogelAcademyVideoStatus["UPLOADING"] = "uploading";
})(VogelAcademyVideoStatus || (exports.VogelAcademyVideoStatus = VogelAcademyVideoStatus = {}));
exports.vogelAcademyVideoStatusTranslation = (_a = {},
    _a[VogelAcademyVideoStatus.CANCELLED] = 'Annulée',
    _a[VogelAcademyVideoStatus.ERROR] = 'Erreur',
    _a[VogelAcademyVideoStatus.PROCESSING] = 'Traitement',
    _a[VogelAcademyVideoStatus.READY] = 'Prête',
    _a[VogelAcademyVideoStatus.UPLOADING] = 'Import',
    _a);
//# sourceMappingURL=vogelAcademy.js.map